import React, { useEffect, useState } from "react";
import FormCreator from "../../components/forms/FormCreator";
import { CreateResourcesData } from "./data/CreateResources.Data";
import { useRef } from "react";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { Suspense } from "react";
import Buttons from "../../components/ui/button/Buttons";
import { useLazyGetAllDropDownForEventManagementQuery } from "../../app/services/EventManagement/EventManagementApi";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { useAddEditResourcesMutation } from "../../app/services/ResourceManagement/ResourseApi";
import SwalAlert from "../../services/swalService/SwalService";
import { useNavigate } from "react-router-dom";
import { useLazyGetPDFQuery, useStoreBase64ImageMutation, useUploadPDFMutation } from "../../app/services/common/commonServiceApi";
import { useCallback } from "react";
import ToastService from "../../services/toastService/ToastService";
import handleFieldChange from "./utils/handleFieldChange";
import { saveAs } from 'file-saver'

const CreateResourcesForm = () => {
  const createResourceRef = useRef();
  // const id = useParams();
  const [createResourceForm, setCreateResourceForm] = useState(CreateResourcesData);
  const { confirm, success, error } = SwalAlert();
  const navigate = useNavigate();

  
  const viewListDropDowns = [
    { dropdownName: "ResourceType", fieldId: "resourcetype" },
    { dropdownName: "ResourceTopic", fieldId: "resourceTopicId" },
  ];
  const [uploadedFileName, setUploadedFileName] = useState({
    ResourceImage: "",
    UploadEncFeatureFileName: "",
    ResourceSpeakerImage: "",
    UploadEncSpeakerFileName: "",
    ReportFileName:"",
    ReportEncFileName:""
  });
  const [showSpeakerFields, setShowSpeakerFields] = useState(false);

  const [geEventListDropDown, { isLoading: viewEventListDropDownIsLoading, data: viewEventListDropDownData, isSuccess: viewEvenetListDropDownIsSuccess }] = useLazyGetAllDropDownForEventManagementQuery();
  const [addEditResource, { isLoading: addResourceIsLoading, isSuccess: addResourceIsSuccess, data: addResourceResponse }] = useAddEditResourcesMutation();
  const [imageUpload, { isLoading: isImageLoading, isSuccess: isImageSuccess, data: uploadImgResponse }] = useStoreBase64ImageMutation();
  const [uploadFile, { isSuccess: isFileSuccess, isLoading: isFileLoading, data: uploadFileResponse }] = useUploadPDFMutation();
  const [getPDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF, data: getPDFData }] = useLazyGetPDFQuery();
  
  useEffect(() => {
    geEventListDropDown();
  }, []);
 
  // Effect for set dropdown
  useEffect(() => {
    if (!viewEventListDropDownIsLoading && viewEvenetListDropDownIsSuccess && viewEventListDropDownData) {
      // Updates dropdown fields in the form based on the fetched data
      setAllDropDownFieldsBatch(CreateResourcesData, viewListDropDowns, viewEventListDropDownData);
    }
  }, [viewEventListDropDownIsLoading, viewEvenetListDropDownIsSuccess, viewEventListDropDownData]);

  useEffect(() => {
    if (!addResourceIsLoading && addResourceIsSuccess && addResourceResponse) {
      if (addResourceResponse.hasError === false) {
        success("Resource has been added successfully !");
        handleBack();
      }
      else {
        error(addResourceResponse.errorMessage)
      }
    }
  }, [addResourceIsLoading, addResourceIsSuccess, addResourceResponse]);

  useEffect(() => {
    if (!isImageLoading && isImageSuccess && uploadImgResponse) {
        let storagePath = uploadImgResponse?.fileName?.split("\\")[1];
        setUploadResponseFileName(storagePath, uploadImgResponse?.uploadedFileName, uploadImgResponse?.fileName);
        ToastService.success("Image has been uploaded successfully !");
    }
}, [isImageLoading, isImageSuccess, uploadImgResponse]);

useEffect(() => {
  if (!isLoadingGetPDF && isSuccessGetPDF && getPDFData) {
    saveAs(getPDFData.fileData, getPDFData.fileName);
  }
}, [isLoadingGetPDF, isSuccessGetPDF, getPDFData]);

  // Handle file upload success and update state
  useEffect(() => {
    if (!isFileLoading && isFileSuccess && uploadFileResponse) {
      const storagePath = uploadFileResponse?.fileName?.split("\\")[1];
      setUploadResponseFileName(storagePath, uploadFileResponse?.uploadedFileName, uploadFileResponse?.fileName);

    }
  }, [isFileLoading, isFileSuccess, uploadFileResponse]);

  const handleSave = () => {
    const resourceFormData = createResourceRef?.current?.getFormData();
    if(!resourceFormData){
     return  error("Please fill all mandatory fields.", "")
    }
    let request = {
      ResourceId: null,
      ResourceName: resourceFormData?.resourceName || null,
      ResourceTypeId: resourceFormData?.resourceType?.value || null,
      // ResourceTopicId: resourceFormData?.resourceTopicId?.value || null,
      ResourceTopicIds: resourceFormData?.resourceTopicId?.value || resourceFormData?.resourceTopicId?.value || resourceFormData?.resourceTopicId.join(', '),
      ResourceImage: uploadedFileName?.ResourceImage || null,
      EncryptedResourceImage: uploadedFileName?.UploadEncFeatureFileName || null,
      IsPage: resourceFormData?.format == "page" ? true : false,
      IsVideo: resourceFormData?.format == "video" ? true : false,
      VideoUrl:resourceFormData?.videoUrl,
      IsReport: resourceFormData?.format == "report" ? true : false,
      ReportUploadFileName:uploadedFileName?.ReportFileName || null,
      ReportEncFileName:uploadedFileName?.ReportEncFileName || null,
      IsRedirectTo:resourceFormData?.format =="redirectTo" ? true : false,
      RedirectToUrl: resourceFormData?.redirectUrl,
      Speaker: resourceFormData?.speaker || null,
      ResourceSpeakerImage: uploadedFileName?.ResourceSpeakerImage|| null,
      UploadedEncSpeakerFileName: uploadedFileName?.UploadEncSpeakerFileName || null,
      PublishDate: resourceFormData?.publishDate || null,
      PublishTime:resourceFormData?.publishTime || null,
      UnpublishDate:resourceFormData?.unPublishDate || null,
      UnpublishTime:resourceFormData?.unPublishTime || null
    }
    addEditResource(request)
    console.log(request)
  }
  const handleFileUpload = useCallback((fieldName, fileInfo) => {
    const formData = new FormData();
    formData.append("file", fileInfo?.file);
    formData.append("storagePath", fieldName);
    uploadFile(formData);
  }, []);
  
  const setUploadResponseFileName = (fieldName, fileName, encFileName) => {
    const validFields = {
      ResourceImage: "UploadEncFeatureFileName",
      ResourceSpeakerImage: "UploadEncSpeakerFileName",
      ReportFileName:"ReportEncFileName"
    };
    if (validFields[fieldName]) {
        setUploadedFileName((prevState) => ({
            ...prevState,
            [fieldName]: fileName,
            [validFields[fieldName]]: encFileName,
        }));
    }
};

const handleImageUpload = useCallback((fileDetails, storagePath) => {
  const request = {
    fileName: fileDetails?.fileName,
    fileStr: fileDetails?.base64Data,
    storagePath: storagePath,
  };
imageUpload(request);
}, [imageUpload]);

const handleActionChange = (action, dataField) => {
  if (action === "DOWNLOAD") {
    handleDownload(dataField)
  }
  if(action === "Add_Discription"){
    handleAddDescription()
  }
}

const handleDownload = (dataField) => {
  const fetchEncFileName = {
    ResourceImage: "UploadEncFeatureFileName",
    ResourceSpeakerImage: "UploadEncSpeakerFileName",
    ReportFileName:"ReportEncFileName",
  };
  let fileName = fetchEncFileName[dataField];
  if (uploadedFileName?.[fileName]?.includes('.png') || uploadedFileName?.[fileName]?.includes('Images\\') || uploadedFileName?.[fileName]?.includes('.pdf') ) {
    let request = {
      type: dataField,
      fileName: uploadedFileName?.[fileName]
    }
    getPDF(request)
  }
  else {
    let request = {
      type: dataField,
      fileName: uploadedFileName?.[fileName],
    }
    getPDF(request)
  }
}
const handleAddDescription = () => {
  setShowSpeakerFields(true);
};

// Memoized handler for optimized field changes
const memoizedHandleFieldChange = useCallback(
  (dataFieldName, updateFormData) => {
    if (dataFieldName === "displayFeatureImage") {
      return handleImageUpload(updateFormData?.displayFeatureImage, "ResourceImage");
    }
    else if (dataFieldName === "displaySpeakerImage") {
      return handleImageUpload(updateFormData?.displaySpeakerImage, "ResourceSpeakerImage");
    }
    else if (dataFieldName === "format") {
      return handleFieldChange(dataFieldName, updateFormData, CreateResourcesData,handleFileUpload)
    }
    else if( ["ReportFileName"].includes(dataFieldName) ){
      handleFileUpload(dataFieldName, updateFormData[dataFieldName]);
    }
    else {
      return handleFieldChange(dataFieldName, updateFormData, CreateResourcesData);
    }
  },
  [setCreateResourceForm, handleImageUpload]
);

const handleBack = () => { navigate('/viewResources') }

  return (
    <div>
      <div className="membership-application">
        <div className="form-card mt-4">
         
            <Suspense fallback={<DataLoader />}>
            {viewEventListDropDownData &&  
            <>
            <div className="row">
                <FormCreator
                  ref={createResourceRef}
                  config={createResourceForm}
                  key={false}
                  onActionChange={handleActionChange}
                  onColumnChange={memoizedHandleFieldChange}
                />
              </div>
              <div className="">
                <Buttons
                  onClick={handleSave}
                  buttonText={"Save"}
                  buttonTypeClassName="theme-btn btn mt-auto"
                  isLoading={false}
                />
              </div>
              </>
                  }
            </Suspense>
      
        </div>
      </div>
    </div>
  );
};

export default CreateResourcesForm;
